import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatClaim',
})
export class FormatClaimPipe implements PipeTransform {
  transform(fileNumber: string, format: string): string {
    if (!fileNumber) {
      return fileNumber;
    }

    let output = fileNumber;
    if (format && format.length > 0) {
      let currentPosition = format.indexOf('-');
      while (currentPosition > 0 && currentPosition <= output.length) {
        output =
          output.slice(0, currentPosition) +
          '-' +
          output.slice(currentPosition);
        currentPosition = format.indexOf('-', currentPosition + 1);
      }
    }

    return output;
  }
}
